import React, { FC } from 'react';
import { Box, Container, Grid, Theme, Typography, useMediaQuery } from '@material-ui/core';
import Image from 'next/image';
import { WirelineIcon, WirelineSecondIcon } from '../../../svgs/expertise';
import { createStyles, makeStyles } from '@material-ui/styles';

interface TextBlockWithImageProps {
  image: string;
  title: string;
  description: string;
  listItems: Array<{ title: string; description: any }>;
  isLeftImage?: boolean;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    title: {
      color: theme.palette.primary.main,
      fontSize: 40,
      fontWeight: 900,
      lineHeight: '40px',
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(3),
      [theme.breakpoints.up('md')]: {
        fontSize: 48,
        lineHeight: '57px',
      },
    },
    description: {
      color: '#4F5260',
      fontSize: 20,
      fontWeight: 500,
      [theme.breakpoints.up('md')]: {
        fontSize: 24,
      },
    },
    gridContainer: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    gridItem: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'stretch', // Растягиваем блоки по высоте
    },
    listBox: {
      backgroundColor: theme.palette.primary.main,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flex: 1,
      padding: '16px',
      border: '1px solid #ddd',
      borderRadius: '4px',
    },
    itemTitle: {
      color: '#F7F7F7',
      fontSize: 25,
      fontWeight: 700,
      lineHeight: '30px',
      [theme.breakpoints.up('md')]: {
        fontSize: 32,
      },
    },
    itemDescription: {
      color: '#F7F7F7',
      fontSize: 15,
      fontWeight: 500,
      marginTop: 10,
      [theme.breakpoints.up('md')]: {
        fontSize: 16,
      },
    },
    icon: {
      marginLeft: -330,
      [theme.breakpoints.up('sm')]: {
        marginLeft: -175,
      },
      [theme.breakpoints.up('md')]: {
        marginLeft: -245,
      },
      [theme.breakpoints.up('lg')]: {
        marginLeft: -80,
      },
      [theme.breakpoints.up('xl')]: {
        marginLeft: -30,
      },
    },
    container: {
      overflow: 'hidden',
    },
  });
});

const TextBlockWithImage: FC<TextBlockWithImageProps> = (props) => {
  const { image, listItems, title, description, isLeftImage } = props;
  const classes = useStyles();
  const isMediumUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  return (
    <Container fixed data-aos="fade-up" data-aos-delay="400">
      <Grid className={classes.container} container spacing={4}>
        {isLeftImage && isMediumUp ? (
          <>
            <Grid item md={6} xs={12}>
              <Image src={image} alt={title} width={690} height={500} />
            </Grid>
            <Grid item md={6} xs={12}>
              <WirelineSecondIcon style={{ width: '100%' }} />
              <Typography className={classes.title}>{title}</Typography>
              <Typography className={classes.description}>{description}</Typography>
            </Grid>
          </>
        ) : (
          <>
            <Grid item md={6} xs={12}>
              <WirelineIcon className={classes.icon} />
              <Typography className={classes.title}>{title}</Typography>
              <Typography className={classes.description}>{description}</Typography>
            </Grid>
            <Grid item md={6} xs={12}>
              <Image src={image} alt={title} width={690} height={500} />
            </Grid>
          </>
        )}
      </Grid>
      <Grid container spacing={4} className={classes.gridContainer}>
        {listItems.map((item, index) => {
          const isLastItem = index === listItems.length - 1;
          const isOddCount = listItems.length % 2 !== 0;
          const gridMd = isLastItem && isOddCount ? 12 : 6;

          return (
            <Grid key={index} item md={gridMd} xs={12} className={classes.gridItem}>
              <Box className={classes.listBox}>
                <div>
                  <Typography
                    style={isLastItem && isOddCount ? { textAlign: 'center' } : { textAlign: 'left' }}
                    className={classes.itemTitle}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    style={isLastItem && isOddCount ? { textAlign: 'center' } : { textAlign: 'left' }}
                    className={classes.itemDescription}
                  >
                    {item.description}
                  </Typography>
                </div>
              </Box>
            </Grid>
          );
        })}
      </Grid>
      <Box mb={isMediumUp ? 23 : 12} />
    </Container>
  );
};

export default TextBlockWithImage;
